import {announce} from '@github-ui/aria-live'
import {useEffect} from 'react'

import {AGENT_MERGE_UNAVAILABLE_MESSAGE} from '../../page-data/payloads/agent-merge'

/**
 * Announces a failed settings load. Unlike save feedback — which is announced from the mutation
 * callbacks of the surface that initiated it — a load error has no initiator, so every mounted
 * surface would announce it. `claimAnnouncement` lets a single surface speak for all of them.
 */
export function useAgentMergeLoadAnnouncement({
  isAvailable,
  claimAnnouncement,
  error,
  isError,
}: {
  isAvailable: boolean
  claimAnnouncement: (transition: 'loading' | 'error') => boolean
  error: Error | null
  isError: boolean
}) {
  useEffect(() => {
    if (isAvailable && isError && error && claimAnnouncement('error')) {
      announce(AGENT_MERGE_UNAVAILABLE_MESSAGE, {assertive: true})
    }
  }, [claimAnnouncement, isAvailable, isError, error])
}
